/**
 * Vaktplan | Oppgaver (#293): the two views of the planner area, as the candidate-8 design draws them.
 * Rendered by the router above each page, so Vaktplan.tsx itself is not touched (#280/#290 own it).
 */
import { T } from '@/i18n';
import { NavLink } from 'react-router-dom';
import './oppgaver.css';

export function PlanTabs() {
  return (
    <nav className="o-ptabs" aria-label={T('Planlegging')}>
      <NavLink to="/vaktplan" end>
        {T('Vaktplan')}
      </NavLink>
      <NavLink to="/vaktplan/oppgaver">{T('Oppgaver')}</NavLink>
    </nav>
  );
}
